module.exports = __webpack_public_path__ + "media/images/svg-icon/verticle-2258019e03512350cf0f999a57ce9ede.svg";